import Lang from '@/mixins/Lang'
import ll from '@/lang';

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        Vue.Lang = ll;
        
        Vue.mixin(Lang);

    }
}
